import confetti from "canvas-confetti";

const COLORS = ["#7C3AED", "#8B5CF6", "#22C55E", "#F4F1FA"];

export function celebrate() {
  try {
    confetti({ particleCount: 130, spread: 90, startVelocity: 42, origin: { y: 0.6 }, colors: COLORS, zIndex: 9999 });
    const end = Date.now() + 800;
    (function frame() {
      confetti({ particleCount: 4, angle: 60, spread: 55, origin: { x: 0 }, colors: COLORS, zIndex: 9999 });
      confetti({ particleCount: 4, angle: 120, spread: 55, origin: { x: 1 }, colors: COLORS, zIndex: 9999 });
      if (Date.now() < end) requestAnimationFrame(frame);
    })();
  } catch (e) { /* no-op */ }
}
